import {
  Component,
  ElementRef,
  ViewChild,
  Input,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
} from "@angular/core";
import { UserService, AppDataSharingService } from "@pulse/common";
import { de, it, languageMappings, pt } from "./ot-language-files";
declare var csui: any;
@Component({
  selector: "script-hack",
  template: `
    <div #script style.display="none">
      <ng-content></ng-content>
    </div>
  `,
})
export class ScriptHackComponent implements OnInit, OnDestroy {

  @Output()
  onScriptLoadEvent =  new EventEmitter<boolean>()

  @Input()
  src: string;

  @Input()
  type: string;

  @Input() isItWidgetUrl: boolean = false;

  @ViewChild("script", { static: true }) script: ElementRef;

  userPreferredLanguage: string = "en";
  userPreferredDateFormat: string = "MM/DD/YYYY";
  mappings = languageMappings;

  constructor(private userService: UserService,
    private dataSharingService: AppDataSharingService) {}

  ngOnInit(): void {
    const userInfo = this.userService.getUserInfo();
    const dateFormat = this.userService.getDateFormat();
    this.userPreferredLanguage = userInfo?.preferences?.["language-code"] || "en";
    this.userPreferredDateFormat = userInfo?.preferences?.["date-format"] || "MM/DD/YYYY";
  }
  convertToScript() {
    var element = this.script.nativeElement;
    var script = document.createElement("script");

    if (this.isItWidgetUrl) {
      script.setAttribute("id", "widgets_url");

      const langCode = this.mappings[this.userPreferredLanguage.toLowerCase()];

      script.onload = () => this.setLanguage(langCode);
    }
    script.type = this.type ? this.type : "text/javascript";
    if (this.src) {
      script.src = this.src;
    }
    if (element.innerHTML) {
      script.innerHTML = element.innerHTML;
    }

    var parent = element.parentElement;
    parent.parentElement.replaceChild(script, parent);
  }

  setLanguage(lang: string) {
    //this.dataSharingService.csuiLoaded.next(true);
    this.onScriptLoadEvent.emit(true);
    csui.setLanguage(lang?.toLowerCase());

    if (lang.toLowerCase() == "de")
      csui.define(
        "xecmpf/widgets/integration/folderbrowse/impl/nls/de/localized.strings",
        de
      );

    if (lang.toLowerCase() == "it") {
      csui.define(
        "csui/controls/tabletoolbar/impl/nls/it/localized.strings",
        it
      );
    }

    if (lang.toLowerCase() == "pt") {
      csui.define("csui/models/impl/nls/pt/lang", pt);
    }

    csui.require.config({
      config: {
        "nuc/utils/types/date": {
          dateFormat: this.userPreferredDateFormat.toLocaleUpperCase()
        }
      }
    })
  }

  ngAfterViewInit() {
    this.convertToScript();
  }

  ngOnDestroy(): void {}
}
